<template>
  <div class="interstitial interstitial--school">
    <b-container class="text-center">
      <b-row align-h="center">
        <b-col md="8" sm="12">
          <icon-flag />
          <template v-if="user.path !== 'unknown'">
            <h2><span class="underline text-reset">Sweet</span>. Let’s talk college choice.</h2>
          </template>
          <template v-else>
            <h2><span class="underline text-reset">No worries</span>. We’ll guide you through, starting with college choice.</h2>
          </template>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import IconFlag from '../animatedicons/IconFlag.vue'

export default {
  name: 'SchoolInterstitial',
  props: {
    user: Object
  },
  data () {
    return {
      duration: this.user.path === 'unknown' ? 4000 : 2500
    }
  },
  components: {
    IconFlag
  },
  mounted: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    this.delay = window.setTimeout(() => this.$emit('completed'), this.duration);
    container.classList.add('container-hidden');
  },
  destroyed: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    window.clearTimeout(this.delay);
    container.classList.remove('container-hidden');
  }
}
</script>

<style scoped>
</style>
